class BurgerMenu {
  static init(pageScroller) {
    let menu = document.querySelector('.menu-container');
    let burger = document.querySelector('.burger');
    let logo = document.querySelector('.logo-wrapper')
    let links = document.querySelector('header .links');
    let header = document.querySelector('header');
    let filter = document.querySelector('.filter')
    let btn = document.querySelector('.links .btn')
    let open = false;
    burger.addEventListener('click', function (e) {
      if (open) {
        menu?.classList.remove('no-transition')
        setTimeout(() => {
          menu.classList.remove('open');
          burger.classList.remove('open');
          logo.classList.remove('open')
          links.classList.remove('open')
          header.classList.remove('open')
          filter?.classList.remove('open')
          pageScroller.pauseSmoothScroll(false);
        }, 20)
        if (btn?.classList.contains('btn-secondary')) {
          btn.classList.add('btn-primary')
          btn.classList.remove('btn-secondary')
        }
        open = false;
      } else {
        setTimeout(() => {
          menu?.classList.add('no-transition')
        }, 300)
        menu.classList.add('open');
        burger.classList.add('open');
        logo.classList.add('open')
        links.classList.add('open')
        header.classList.add('open')
        filter?.classList.add('open')
        pageScroller.pauseSmoothScroll(true);
        if (btn?.classList.contains('btn-primary')) {
          btn.classList.remove('btn-primary')
          btn.classList.add('btn-secondary')
          btn.classList.add('white')
        }
        open = true;
      }
    });

    document.addEventListener('click', function (e) {
      if (menu.classList.contains('open')) {
        if (!menu.contains(e.target) && !burger.contains(e.target)) {
          menu?.classList.remove('no-transition')
          setTimeout(() => {
            menu.classList.remove('open');
            burger.classList.remove('open');
            logo.classList.remove('open')
            links.classList.remove('open')
            header.classList.remove('open')
            filter?.classList.remove('open')
            pageScroller.pauseSmoothScroll(false);
          }, 20)
          if (btn?.classList.contains('btn-secondary')) {
            btn.classList.add('btn-primary')
            btn.classList.remove('btn-secondary')
          }
          open = false;
        }
      }
    });
  }
}

export default BurgerMenu;
